
export enum AIVoice {
    FR_FR_VIVIENNE = "FR_FR_VIVIENNE",
    US_AVIA = "US_AVIA",
    US_EMMA = "US_EMMA",
    DE_SERPHINA = "DE_SERPHINA",
    ZN_XIAO = "ZN_XIAO",
    EN_US_JENNY = "EN_US_JENNY",
    ES_ES_ISIDORA = "ES_ES_ISIDORA",
    ES_ES_ARABELLA = "ES_ES_ARABELLA",
    IT_IT_ISABELLA = "IT_IT_ISABELLA",
    PT_BR_THALITA = "PT_BR_THALITA",
    ZH_CN_XIAOCHEN = "ZH_CN_XIAOCHEN",
    EN_US_RYAN = "EN_US_RYAN",
    EN_US_ANDREW = "EN_US_ANDREW",
    EN_US_BRYAN = "EN_US_BRYAN",
    DE_DE_FLORIAN = "DE_DE_FLORIAN",
    FR_FR_REMY = "FR_FR_REMY",
    IT_IT_MARCELLO = "IT_IT_MARCELLO",
    IT_IT_ALESSIO = "IT_IT_ALESSIO",
    JP_JP_MASARU = "JP_JP_MASARU",
    ZH_CN_YUNKI = "ZH_CN_YUNKI"
}
